const json = {
    GE: {
        home: 'გაზიარებული ემოციები ',
        about: 'კამპანიის შესახებ',
        statistics: 'რიცხვები და ემოციები',
        privacy: 'Privacy Policy',
        terms: 'Terms of Use',
        'home.contributor.step2': 'სერთიფიკატი',
        'home.book.bookStep3': 'გზამკვლევი'
    },
    EN: {
        home: 'Shared Emotions',
        about: 'About',
        statistics: 'Figures & Feelings',
        privacy: 'Privacy Policy',
        terms: 'Terms of Use',
        'home.contributor.step2': 'Certificate of Graditute',
        'home.book.bookStep3': 'Guidebook'
    }
}

export default json



// WEBPACK FOOTER //
// ./client/app/app.texts.js